
import { Grid, CardContent, Typography, Box } from "@mui/material";
import useTracking from "../../hooks/useTracking";

const features = [
  {
    image: "/becomepartnerimages/INCREMENTAL SALES AND EXPOSURE.png",
    title: "INCREMENTAL SALES AND EXPOSURE",
    description:
      "Increase your sales and reach new customers. Our commercial team is here to make your growth journey simple.",
  },
  {
    image: "/becomepartnerimages/SOPHISTICATED DIGITAL CHANNEL.png",
    title: "A SOPHISTICATED DIGITAL CHANNEL",
    description:
      "Showcase your products with beautiful photos and customize your menu in real-time. A sophisticated, intuitive online experience.",
  },
  {
    image: "/becomepartnerimages/STREAMLINED END-TO-END LOGISTICS.png",
    title: "STREAMLINED END-TO-END LOGISTICS",
    description:
      "Get your products delivered efficiently. We take care of everything from customization to feedback. Unparalleled customer support.",
  },
];

const FeatureSection = () => {

 const { ref} = useTracking("FeatureSection");

  return (
    <Grid   ref={ref}  container sx={{padding:"10px"}}>
      {features.map((feature, index) => (
        <Grid item xs={12} sm={4} md={4} key={index}>
         
            <Box
            component={"img"}
              src={feature.image}
              alt={feature.title}

              sx={{width:{xs:"100%",sm:"100%",md: "426px",lg: "426px",},
            height:{xs:"auto",sm:"auto",md: "446px",lg: "446px",}
            }}
              // style={{ width: "426px", height: "446px", objectFit: "contain" ,borderRadius:"20px"}}
            />
       
          <CardContent>
            <Typography variant="h6" fontWeight="bold" sx={{textAlign:'left',color:"#1B1D4D",}}>
              {feature.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={1} sx={{textAlign:'left',fontFamily: 'Poppins' }}>
              {feature.description}
            </Typography>
          </CardContent>
        </Grid>
      ))}
    </Grid>
  );
};

export default FeatureSection;
